var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TituloFijo",attrs:{"id":"TituloFijo"}},[_c('p',{staticClass:"titulo lastProTitulo"},[_c('span',{staticClass:"oa"},[_vm._v(_vm._s(this.number))]),_vm._v(_vm._s(this.titulo))])])
}
var staticRenderFns = []

export { render, staticRenderFns }